//@flow
import React from 'react'
import styled from 'styled-components'
import { H3, H4, H5, H6, TextLarge } from '../TextPrimitives'
import { transparentUI } from '../../style-functions'
// import Button from '../Button'

const Wrapper = styled.div`
  width: ${({ expand }) => (expand ? 'calc(100vw - 10rem)' : '40rem')};
  height: ${({ expand }) => (expand ? 'calc(100vh - 33rem)' : 'initial')};
  padding: 4rem 4rem;
  border-radius: 0.5rem;
  color: ${({ theme }) => theme.colors.text.inverse};
  will-change: transform;
  ${transparentUI};
`

const Layout = styled.div`
  display: flex;
  height: 100%;
`

const Grid = styled.div`
  display: grid;
  width: 66%;
  height: 100%;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 4rem;
  margin-right: 8rem;
`

const Thumb = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => (props.expand ? '37.5%' : '100%')};
  padding-top: ${({ expand }) => (expand ? 6 : 0)}rem;
`

// top: 5rem;
//   right: 5rem;
//   width: initial;
//   padding: 8rem 12rem;

const YearLarge = styled(H3)`
  margin-bottom: 4rem;
`

const TitleLarge = styled(H4)`
  margin-bottom: 2rem;
`

const YearSmall = styled(H5)`
  margin-bottom: 4rem;
`

const TitleSmall = styled(H6)`
  margin-bottom: 2rem;
`

const Paragraph = styled.p`
  margin-bottom: 1rem;
`

// const ExploreButton = styled(Button)`
//   margin-top: ${props => (props.expand ? 4 : 2)}rem;
//   align-self: center;
// `

type Image = {
  url: string,
}

type TopicType = {
  start: number,
  end: number,
  name: string,
  images: Image[],
}

const TopicLayer = ({
  topic,
  text,
  expand,
  clickHandler,
}: {
  topic: TopicType,
  text: string,
  expand: boolean,
  clickHandler: Function,
}) => {
  if (!topic) return null
  const { start, end, name, images } = topic
  const Year = expand ? YearLarge : YearSmall
  const Title = expand ? TitleLarge : TitleSmall
  return (
    <Wrapper expand={expand}>
      <Layout>
        {expand && (
          <Grid>
            {images.map(image => (
              <Thumb key={image.url} src={image.url} alt="" />
            ))}
          </Grid>
        )}
        <TextContent expand={expand}>
          <Year>{`${start} – ${end}`}</Year>
          <Title>{name}</Title>
          {expand && (
            <TextLarge expand={expand}>
              {text.split('***').map((paragraph, i) => (
                <Paragraph key={`paragraph-${i}`}>{paragraph}</Paragraph>
              ))}
            </TextLarge>
          )}
          {/* <ExploreButton
            text={expand ? 'Periode entdecken' : 'Mehr erfahren'}
            size="medium"
            expand={expand}
            onClick={clickHandler}
          /> */}
        </TextContent>
      </Layout>
    </Wrapper>
  )
}

TopicLayer.defaultProps = {
  clickHandler: x => x,
}

export default TopicLayer
